<div class="card {{ size }}" [class.has-collapsible]="collapsibleInfo">
  <div class="card__main">
    <div class="card__icon" [class.card__icon--inverted]="inverted">
      @if (inverted) {
        <img
          src="./../../../assets/icons/wallet/currency-circle-dollar-thin-inverted.svg"
          alt="icone simbolo valores na carteira" />
      } @else {
        <img
          src="./../../../assets/icons/wallet/currency-circle-dollar-thin.svg"
          alt="icone simbolo valores na carteira" />
      }
    </div>
    <div class="card__info">
      <span class="card__tittle">{{ title }}</span>
      <span class="card__data">{{ data }}</span>
    </div>
    @if (collapsibleInfo) {
      <button class="card__toggle" (click)="toggleCollapse()" type="button" [attr.aria-expanded]="isExpanded">
        <i class="pi" [ngClass]="isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
      </button>
    }
  </div>
  @if (collapsibleInfo && isExpanded) {
    <div class="card__collapsible">
      <p>{{ collapsibleInfo }}</p>
    </div>
  }
</div>
